export default "__VITE_ASSET__CdXmmRP9__"